import Abstract from './class.Abstract';
import Input from './class.Input';
import { qs } from '../dom-helpers';

class ProductBlock extends Abstract {
  constructor() {
    super();

    this.productBlocks = document.querySelectorAll('.product-item');

    if (this.productBlocks.length) {
      this.init();
    }
  }

  init() {
    this._initQuantityButtons();
    this._initQuantityInputs();
    this._disableAddToCartButtonWhileAdding();
  }

  _initQuantityButtons() {
    this.productBlocks.forEach((productBlock) => {
      productBlock.addEventListener('click', (e) => {
        const node = e.target;

        if (!node.classList.contains('product__quantity-btn')) return;
        e.preventDefault();

        const buttonType = node.classList.contains('product__quantity-btn--plus') ? 'inc' : 'dec';
        const addToCartButton = qs('.ajax_add_to_cart', productBlock);
        let newValue = 0;
        let input = null;

        if (buttonType === 'inc') {
          newValue = parseInt(node.previousElementSibling.value, 10) + 1;
          input = node.previousElementSibling;
        } else {
          newValue = parseInt(node.nextElementSibling.value, 10) - 1;
          if (newValue <= 1) newValue = 1;
          input = node.nextElementSibling;
        }

        input.value = newValue;
        new Input().updateInputWidth(input);

        addToCartButton.dataset.quantity = newValue;
      });
    });
  }

  _initQuantityInputs() {
    this.productBlocks.forEach((block) => {
      const quantityInput = block.querySelector('.qty');
      const addToCartButton = block.querySelector('.add-to-cart-btn');

      if (!quantityInput || !addToCartButton) return;

      quantityInput.addEventListener('change', () => {
        addToCartButton.dataset.quantity = quantityInput.value;
      });
    });
  }

  _disableAddToCartButtonWhileAdding() {
    jQuery(document.body).on('adding_to_cart', (data, button) => {
      const actionBlock = button[0].closest('.product__actions');
      jQuery(actionBlock).block(this.getBlockSettings());

      return ((node) => {
        jQuery(document.body).on('added_to_cart', () => {
          jQuery(node).unblock();

          button[0].dataset.quantity = 1;
          jQuery(actionBlock).find('.qty').val(1);
        });
      })(actionBlock);
    });
  }
}

export default ProductBlock;
